import React from 'react';
import { ArrowRight } from 'lucide-react';

/** Absolute /app paths for landing (served separately from LMS-ui) */
export const ROLE_LOGIN_LINKS = [
  { name: 'Super Admin', href: '/app/superadmin/login' },
  { name: 'Institution', href: '/app/university/login' },
  { name: 'Teacher', href: '/app/teacher/login' },
  { name: 'Student', href: '/app/login' },
  { name: 'Parent', href: '/app/parent/login' },
  { name: 'Counsellor', href: '/app/counsellor/login' },
  { name: 'IAM', href: '/app/iam/login' },
];

const RoleLoginLinks = ({ className = '', linkClassName = '' }) => {
  return (
    <nav className={`flex flex-col gap-1 ${className}`} aria-label="Portal logins">
      {ROLE_LOGIN_LINKS.map((link) => (
        <a
          key={link.href}
          href={link.href}
          className={`group inline-flex items-center justify-between gap-3 py-2 text-sm font-medium transition-colors ${linkClassName}`}
        >
          <span>{link.name}</span>
          <ArrowRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
        </a>
      ))}
    </nav>
  );
};

export default RoleLoginLinks;
